export default {
  checkType(testArray){
    if(testArray instanceof Array) {
      return testArray
    } else {
      return [testArray]
    }
  }
}